import React, { useState, useEffect, useMemo } from "react";
import {
    Button, Modal, Input, Tree, Skeleton, Tooltip, Progress
} from "antd";
import {
    CloseOutlined, FolderOpenFilled, FolderFilled,
    WarningOutlined
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import useSearchInTree from "../../hooks/Tree/useSearchInTree";
import useCountSegmentInTree from "../../hooks/Tree/useCountSegmentInTree";
import { checkIfhasSetToDisplayOnly, getCountryCode, getModuleCode, getModuleName, getSelectedAnalysis } from "../../utils/oneintelligence/OneIntelligenceHelper";
import TreeServices from "../../services/Tree.services";
import { setCheckedWhiteSpaceSelections, setGenerateWhitespaceReport, setWhitespaceCurrentTree } from "../../store/components/Reports.slice";
import { setReportBuilderMode } from "../../store/components/ReportBuilder.slice";
import { loadGenerateGrid } from "../../utils/report/ReportsHelper";
import { deepMergeObjects, folderStyle, formatNumber, getName, isObjAllUndefined } from "../../utils/MainHelper";
import ConfigServices from "../../services/Config.services";
import RenderComponent from "../General/RenderComponent";
import WorkerServices from "../../services/Worker.services";
import { getAnalysisName } from "../../utils/analysis/AnalysisHelper";
import TreeProgress from "../General/TreeProgress";
import useTreeShowLowActivity from "../General/useTreeShowLowActivity";

function WhitespacesSelectionModal({
    visible: {
        show,
        isInclude,
        analysis
    },
    onClose = () => { },
    data
}) {
    const dispatch = useDispatch();

    const [isLoading, setisLoading] = useState(true);
    const [checkedKeys, setcheckedKeys] = useState([]);
    const [expandedKeys, setexpandedKeys] = useState([]);
    const [treeData, settreeData] = useState([]);
    const [percentage, setPercentage] = useState(0)
    const [searchedText, setsearchedText] = useState("");
    const moduleCode = getModuleCode();
    const {
        generateGrid
    } = useSelector((state) => state.reports);
    const {
        setup: {
            marketPackage
        }
    } = useSelector((state) => state.buildTargets);
    const { configuration: { buildedTargets } } = useSelector((state) => state.marketExplorer);

    const onExpand = (selected, info) => {
        setexpandedKeys(selected);
    };

    const onCheck = (checked, info) => {
        setcheckedKeys(info.checkedNodes);
    };

    const { searchedData, loadingSearch } = useSearchInTree(searchedText, treeData);
    const analysisObj = getSelectedAnalysis(analysis);
    const { showLowActivity, lowActComponent } = useTreeShowLowActivity(analysisObj)

    const toDisplayData = useMemo(() => {
        const display = searchedText ? searchedData : treeData;
        
        if (!(analysisObj?.code || analysisObj?.key)?.includes("mokb")) return display
        if (showLowActivity) return display;
        return display.reduce((acc, d) => {
            const children = (d?.children || []).filter(
                (child) => !child.lowActivity
            );
            if (children.length) acc.push(d);
            return acc;
        }, []);
    }, [searchedText, analysisObj, searchedData, treeData, showLowActivity]);

    const segmentCount = useCountSegmentInTree(toDisplayData);

    const percentageCallBack = (percent) => {
        setPercentage(percent)
    }
    useEffect(() => {
        if (show) {
            setisLoading(true);
            const countryCode = getCountryCode("enterprise");
            if (analysis === "mokb_analysis") {
                TreeServices.getAudienceTree(false, analysisObj, percentageCallBack).then((response) => {
                    console.log(response);
                    dispatch(setWhitespaceCurrentTree(response));
                    settreeData(response);
                    setisLoading(false);
                })
            } else {
                const marketPackageCode = marketPackage.code.replace("dev", "");

                const dontFilterConfig = analysisObj?.dontUseFilter?.[marketPackageCode];
                const hardcodeTodisplay = ConfigServices.getDefaultSelectionsCofig()

                TreeServices.getWhiteSpaceTree([2, 3, 4, 5, 6, 7], analysisObj, percentageCallBack).then(async (response) => {
                    const folderLockConfigSpecificModule = analysisObj?.lockFolder?.[marketPackageCode];
                    const folderLockConfigAllModule = analysisObj?.lockFolder?.allmodule;
                    const moduleConfig = deepMergeObjects(folderLockConfigAllModule || {}, folderLockConfigSpecificModule || {});
                    let folderLockConfig = {
                        allcountry: moduleConfig?.allcountry,
                        current: moduleConfig?.[countryCode]
                    }
                    folderLockConfig = isObjAllUndefined(folderLockConfig)
                    if (!folderLockConfig) {
                        const folderLockConfigFromSavant = await ConfigServices.getFolderLockConfig({ module: getModuleName(), marketExplorerCode: analysisObj?.code || analysisObj?.key });
                        folderLockConfig = isObjAllUndefined(folderLockConfigFromSavant)
                    }

                    dispatch(setWhitespaceCurrentTree(response));
                    let newTreeData = [];
                    let brandObj = {};
                    buildedTargets.forEach((aud) => {
                        aud.groups.find((group) => {
                            if (["wp_brands", "wp_medications", "mokb_marketexplorer", "mokb_marketexplorer_main"].includes(group.code)) {
                                brandObj = group;
                            }
                        });
                    });
                    let catnames = null;
                    if (generateGrid.length) {
                        catnames = generateGrid.map((d) => d.name);
                    }
                    const isMeds = ["healthcarewhitespaces", "veterinaryjourney"].includes(marketPackageCode);
                    const dontUseFilter = dontFilterConfig?.includes(countryCode);
                    if (dontUseFilter || ["standardtreatmentjourney", "analysis_politicaltaxonomy", "usersearchjourney"].includes(analysis)) {
                        newTreeData = [...response];
                    } else {
                        const brandTreeData = await TreeServices.getWhiteSpaceTree(undefined, brandObj, percentageCallBack);
                        if ((["whitespacesmodule", "healthcarewhitespaces", "veterinaryjourney"].includes(marketPackageCode))
                            && isInclude
                            && ["candidatewhitespaces", "macrowhitespaces"].includes(analysis)
                            && generateGrid.length) {
                            newTreeData = await WorkerServices.getRelated([
                                [...response],
                                [...brandTreeData], buildedTargets, isInclude, true, catnames, isMeds]);
                        } else {
                            newTreeData = await WorkerServices.getRelated([
                                [...response],
                                [...brandTreeData],
                                buildedTargets, isInclude, false, catnames, isMeds,
                                hardcodeTodisplay[countryCode]]);
                        }
                    }
                    if (["macrowhitespaces", "standardtreatmentjourney",
                        "othermacrowhitespaces"].includes(analysis)) {
                        WorkerServices.lockFolderBaseFromConfig([newTreeData, {
                            hideAllKeywords: true
                        }]).then(async (lockedFolder) => {
                            let filtered = await checkIfhasSetToDisplayOnly(lockedFolder, "selections", analysisObj)
                            if (folderLockConfig) {
                                filtered = await WorkerServices.lockFolderBaseFromConfig([filtered, folderLockConfig])
                            }
                            settreeData(filtered);
                            // dispatch(setWhitespaceCurrentTree(filtered));
                            setisLoading(false);
                        });
                    } else {
                        let filtered = await checkIfhasSetToDisplayOnly(newTreeData, "selections", analysisObj)
                        if (folderLockConfig) {
                            filtered = await WorkerServices.lockFolderBaseFromConfig([filtered, folderLockConfig])
                        }
                        settreeData(filtered);
                        // dispatch(setWhitespaceCurrentTree(filtered));
                        setisLoading(false);
                    }
                    setcheckedKeys([]);
                });
            }
        }
    }, [show, isInclude, analysis, buildedTargets]);

    const onOK = (isAppend) => {
        dispatch(setCheckedWhiteSpaceSelections(checkedKeys));
        dispatch(setReportBuilderMode(analysis));
        dispatch(setGenerateWhitespaceReport(true));
        if (generateGrid.length) {
            if (isAppend === true) { loadGenerateGrid(false, isAppend); } else { loadGenerateGrid(true); }
        }
        onClose({
            show: false,
            isInclude
        });
    };

    const getHeaderText = () => {
        if (analysis === "mokb_analysis") {
            let text = getAnalysisName(analysisObj, moduleCode);
            if (analysisObj?.dontAddAnalysisText) return text;
            return text.includes("Analysis") ? text : text + " Analysis"
        }
        return 'Whitespace Candidates'
    }

    const emptyComponent = () => {
        if (loadingSearch || isLoading) return "";
        let text = "";
        if (searchedText && !searchedData.length) {
            text = "No result found.";
        } else if (!toDisplayData.length) {
            text = "No Data.";
        }
        if (!text) return "";
        return (
            <RenderComponent
                show
                emptyProps={{
                    description: text,
                    style: {
                        width: "calc(100% - 6mm)",
                        height: "95%"
                    },
                    className: "d-flex-col align-items-center justify-content-center"
                }}
            />
        );
    };
    const searchedList = searchedText ? [searchedText] : []
    return (
        <Modal
            className="report--addbehaviouralsegment"
            // className={`report--addbehaviouralsegment ${whiteSpaceInternalAccess() ? "" : "whitespaceClient"}`}
            style={{ width: "100%", height: "100%" }}
            open={show}
            maskClosable={false}
            closable={false}
            title={(
                <div className="d-flex align-items-center" style={{ width: "100%" }}>
                    <div className="flex-1 ellipsis-text">
                        {getHeaderText()}
                    </div>
                    <Button
                        style={{ padding: 0, marginLeft: "5mm" }}
                        type="text"
                        icon={<CloseOutlined />}
                        onClick={() => {
                            onClose({
                                show: false,
                                isInclude
                            });
                        }}
                    />
                </div>
            )}
            footer={(
                <div className="d-flex justify-content-between">
                    <Button onClick={() => {
                        onClose({
                            show: false,
                            isInclude
                        });
                    }}
                    >
                        Cancel
                    </Button>
                    <div className="d-flex">
                        {generateGrid.length
                            ? (
                                <>
                                    <Button
                                        disabled={!checkedKeys.length}
                                        onClick={onOK.bind(null, true)}
                                    >
                                        Append to Report
                                    </Button>
                                    <Button type="primary" disabled={!checkedKeys.length} onClick={onOK}>Generate Report</Button>
                                </>
                            )
                            : <Button type="primary" disabled={!checkedKeys.length} onClick={onOK}>Generate Report</Button>}
                    </div>
                </div>
            )}
        >
            <div className="d-flex-col gap-1 report--addbehaviouralsegment--content">
                <div
                    className="d-flex align-items-center fs-14 fw-400 c-bg-400"
                    style={{
                        height: "5mm",
                        overflow: "hidden"
                    }}
                >
                    <span className="flex-1 ellipsis-text">
                        Add more or remove reports for this category.
                    </span>
                    <Button
                        style={{ padding: "1mm" }}
                        type="link"
                        onClick={() => {
                            // const listTochecked = [];
                            // const checkAllRecursive = (items) => {
                            //     items.forEach((child) => {
                            //         listTochecked.push(child);
                            //         if (child.children && child.children.length) {
                            //             checkAllRecursive(child.children);
                            //         }
                            //     });
                            // };
                            // setcheckedKeys(listTochecked);
                            // checkAllRecursive(toDisplayData);
                            setcheckedKeys(toDisplayData);
                        }}
                    >
                        Include all
                    </Button>
                    <span>|</span>
                    <Button
                        style={{ padding: "1mm" }}
                        type="link"
                        disabled={!checkedKeys.length}
                        onClick={() => {
                            setcheckedKeys([]);
                        }}
                    >
                        Exclude all
                    </Button>
                </div>
                <Input.Search
                    placeholder="Search"
                    style={{ width: "100%" }}
                    value={searchedText}
                    onChange={(e) => {
                        setsearchedText(e.target.value);
                    }}
                    onSearch={(e) => {
                        setsearchedText(e);
                    }}
                />

                <div className="d-flex align-items-center">
                    <span className="flex-1 fs-12 fw-400 c-bg-400 ellipsis-text">
                        {formatNumber(segmentCount)}
                        {" "}
                        reports are available for this category.
                    </span>
                    <span className="fs-12 fw-400 c-b-400">
                        Reports Included:
                        {" "}
                        {checkedKeys.length ? formatNumber(checkedKeys.length) : 0}
                    </span>
                </div>
                {isLoading ? null : lowActComponent}
                <div className="report--addbehaviouralsegment--conttree">
                    <TreeProgress percentage={percentage} />
                    {!isLoading ? (
                        <Tree
                            checkable
                            expandedKeys={expandedKeys}
                            checkedKeys={checkedKeys.map((checked) => checked.key)}
                            onExpand={onExpand}
                            onCheck={onCheck}
                            treeData={toDisplayData}
                            showIcon
                            titleRender={(item) => {
                                const {
                                    name, children, key, folder, lowActivity
                                } = item;
                                if (children || folder) {
                                    return (
                                        <>
                                            {expandedKeys.includes(key)
                                                ? <FolderOpenFilled style={folderStyle} />
                                                : <FolderFilled style={folderStyle} />}
                                            {lowActivity && (
                                                <Tooltip title="Low Activity" placement="right">
                                                    <WarningOutlined
                                                        style={{
                                                            color: "#faad14",
                                                            fontSize: "3mm",
                                                            marginRight: "2mm",
                                                        }}
                                                    />
                                                </Tooltip>
                                            )}
                                            {getName(name, searchedList)}
                                        </>
                                    );
                                }
                                return getName(name, searchedList);
                            }}
                        />
                    ) : <Skeleton paragraph={{ rows: 5 }} active shape="round" />}
                    {emptyComponent()}
                </div>
            </div>
        </Modal>
    );
}

export default WhitespacesSelectionModal;
